import app from '../../app.config';
import {PRODUCTION_WEB_PREFIX} from '../LocationSchema';
import type {_Array, _Object} from '../Paramut';
import type {ScheduleExporter} from '../ScheduleExporter/ScheduleExporter';
import type {Millisecond} from '../Time';

export type City<Mut extends boolean = false> = _Object<
  {
    name: string;
    timezone: string;
  },
  Mut
>;

export type Group<Mut extends boolean = false> = _Object<
  {
    id: number;
    name: string;
    location: {street: string; house: string};
    events: Meetings<Mut>;
  },
  Mut
>;

export type Meetings<Mut extends boolean = false> = _Array<Meeting<Mut>, Mut>;

export type Meeting<Mut extends boolean = false> = _Object<
  {
    id: number;
    /**
     * @example 0
     */
    sequence: number;
    /**
     * @example "2025-10-03T22:06:33.915Z"
     */
    updatedAt: string;
    /**
     * @example 6 // Saturday
     */
    day: number;
    start: _Object<
      {
        hour: number;
        minute: number;
      },
      Mut
    >;
    duration: number;
  },
  Mut
>;

export default async function exportSupportGroupSchedule(
  root: {readonly scheduleExporter: ScheduleExporter},
  now: Millisecond,
  city: City,
  group: Group,
) {
  if (!hasItems(group.events)) {
    return;
  }
  await root.scheduleExporter.export({
    now,
    timezone: city.timezone,
    schedule: group.events,
    address: `${group.location.street} ${group.location.house}, ${city.name}`,
    supportGroupUrl: `${PRODUCTION_WEB_PREFIX}/group/${group.id.toString(10)}`,
    supportGroupName: group.name,
    supportGroupId: group.id,
    notifyBeforeInSeconds: 60 * 60, // an hour
    domain: new URL(PRODUCTION_WEB_PREFIX).hostname,
    projectName: app.name,
    language: 'RU',
  });
}

function hasItems<T>(_: readonly T[]): _ is readonly [T, ...T[]] {
  return _.length > 0;
}
